module.exports = __webpack_public_path__ + "img/moshe.2e9b3f00.png";